module.exports = __webpack_public_path__ + "static/media/icon_alertflag.55af1652.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon_alertflag.svg
// module id = 955
// module chunks = 0